// React Router
import { useNavigate } from 'react-router-dom';

// MUI
import { Box, Typography, Button, createTheme } from '@mui/material'

// Assets
import errgif from "../../assets/error.gif";

export default function Error() {
    const navigate = useNavigate();
    const myTheme = createTheme();
    return (
        <Box sx={{
            margin: "0", width: "100%", height: "100vh", backgroundImage: `url(${errgif})`, backgroundSize: "cover",
            display: "flex", justifyContent: "center", alignItems: "center", gap: "30px", flexDirection: "column"
        }}>
            <Typography variant="h2" sx={{ fontWeight: "bold", color: myTheme.palette.error.main, textAlign: "center" }}>OOPS!...<br />Nothing Is Here</Typography>
            <Button variant="contained" sx={{ backgroundColor: myTheme.palette.error.main, color: "white" }} onClick={() => {
                navigate("/home")
            }}>Go Home</Button>
        </Box>
    )
}